<template>
  <div>
    <section class="list-carteira">
      <b-table
        :id="tableId"
        responsive
        :busy.sync="filtering"
        :fields="table.fields"
        :items="table.items"
        no-local-sorting
      >
        <template #cell(colaborador)="row">
          <span class="d-flex font-weight-bold comprimento_maximo_celulas" v-b-tooltip>
            {{ row.item.nome }}
          </span>
        </template>
        <template #cell(cpf)="row">
          <span class="font-weight-bold comprimento_maximo_celulas">
            {{ row.item.cpf | formataCpfCnpj }}
          </span>
        </template>
        <template #cell(acoes)="row">
          <div class="d-flex align-items-center justify-content-center">
            <div
              v-b-tooltip.hover.bottom
              :title="row.item.possui_vacinacao ? 'Visualizar Carteira de Vacinação do colaborador' : 'Carteira indisponível. Colaborador sem registros de vacinação.'"
              class="button-wrapper"
              :class="{ 'disabled': !row.item.possui_vacinacao }"
              :disabled="!row.item.possui_vacinacao"
            >
              <button
                id="view-vaccination-card"
                class="button-icon text-custom-blue mr-1"
                :class="{ 'disabled': !row.item.possui_vacinacao }"
                :disabled="!row.item.possui_vacinacao"
                @click.prevent="$emit('view-card', row.item)"
                aria-label="Visualizar Carteira de Vacinação"
              >
                <feather-icon icon="EyeIcon" size="18" />
              </button>
            </div>
            <div
              v-b-tooltip.hover.bottom
              :title="row.item.possui_vacinacao ? 'Gerar Carteira de Vacinação em PDF' : 'Carteira indisponível. Colaborador sem registros de vacinação.'"
              class="button-wrapper"
            >
              <button
                v-if="!loadingVaccinationCard[row.item.cpf]"
                id="download-vaccination-card"
                class="button-icon text-custom-blue mr-1"
                :class="{ 'disabled': !row.item.possui_vacinacao }"
                :disabled="!row.item.possui_vacinacao"
                @click.prevent="$emit('generate-card', row.item.cpf)"
                aria-label="Gerar Carteira de Vacinação em PDF"
              >
                <feather-icon icon="DownloadIcon" size="18" />
              </button>
              <b-spinner
                v-else
                small
                variant="primary"
                class="mr-1"
              />
            </div>
          </div>
        </template>
      </b-table>
      <div class="pb-2 px-1">
        <span v-if="withoutResults" class="ml-1">CPF não encontrado ou sem registros de vacinação.</span>
      </div>
    </section>
  </div>
</template>

<script>
import { BTable, BSpinner, VBTooltip } from "bootstrap-vue";

export default {
  name: "CarteiraVacinacaoTableSimple",
  components: {
    BTable,
    BSpinner,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    tableId: {
      type: String,
      default: "tableCarteira"
    },
    filtering: {
      type: Boolean,
      default: false
    },
    table: {
      type: Object,
      required: true
    },
    withoutResults: {
      type: Boolean,
      default: false
    },
    loadingVaccinationCard: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.comprimento_maximo_celulas {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-wrapper.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-icon {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.button-icon:focus {
  outline: none;
}

.button-icon.disabled {
  pointer-events: none;
}
</style>